import API from '../apiCreate'
import { crmLeadApi } from './crmLead'
import { crmLeadParentApi } from './crmLeadParent'
import { crmKanbanApi } from './crmKanban'
import { crmLeadPaymentApi } from './crmLeadPayment'
import { crmStatusApi } from './crmStatus'
import { crmFieldApi } from './crmField'
import { crmNotificationApi } from './crmNotification'
import { crmAutomationApi } from './crmAutomation'
import { crmMessageAutomationApi } from './crmMessageAutomation'
import { crmLeadFunnelApi } from './crmLeadFunnel'
import { crmFunnelApi } from './crmFunnel'

export { API }
export type { CrmApiRequestConfig } from './crmApiRequestConfig'
export { crmLeadApi } from './crmLead'
export { crmLeadParentApi } from './crmLeadParent'
export { crmKanbanApi } from './crmKanban'
export { crmLeadPaymentApi } from './crmLeadPayment'
export { crmStatusApi } from './crmStatus'
export { crmFieldApi } from './crmField'
export { crmNotificationApi } from './crmNotification'
export { crmAutomationApi } from './crmAutomation'
export { crmMessageAutomationApi } from './crmMessageAutomation'
export { crmLeadFunnelApi } from './crmLeadFunnel'
export { crmFunnelApi } from './crmFunnel'

/**
 * Фасад CRM API (обратная совместимость).
 * Новые вызовы предпочтительно брать из доменных `crm*Api`.
 */
export const crmApi = {
  ...crmLeadApi,
  ...crmLeadParentApi,
  ...crmLeadPaymentApi,
  ...crmStatusApi,
  ...crmFieldApi,
  ...crmNotificationApi,
  ...crmAutomationApi,
  kanban: crmKanbanApi,
  messageAutomation: crmMessageAutomationApi,
  leads: crmLeadFunnelApi,
  funnels: crmFunnelApi,
}
